import { idSchema } from "@resume-studio/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const versionTriggerSchema = z.enum([
  "manual",
  "template_change",
  "ai_edit",
  "auto",
  "interval", // 15-minute auto-save
]);

export type VersionTrigger = z.infer<typeof versionTriggerSchema>;

export const documentVersionSchema = z.object({
  id: idSchema,
  documentId: idSchema,
  data: z.record(z.unknown()),
  title: z.string().nullable(),
  trigger: versionTriggerSchema,
  summary: z.string().nullable(), // Human-readable summary of changes
  createdAt: z.date().or(z.dateString()),
});

export class DocumentVersionDto extends createZodDto(documentVersionSchema) {}

// List response without full data to save bandwidth
export const documentVersionListItemSchema = z.object({
  id: idSchema,
  documentId: idSchema,
  title: z.string().nullable(),
  trigger: versionTriggerSchema,
  summary: z.string().nullable(), // Human-readable summary of changes
  createdAt: z.date().or(z.dateString()),
});

export class DocumentVersionListItemDto extends createZodDto(documentVersionListItemSchema) {}
